export function SparkIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.23907 0C3.47522 0 4.47813 1.20332 4.47813 2.68649V9.59859C4.47813 11.0818 3.47522 12.2851 2.23907 12.2851C1.00292 12.2851 0 11.0818 0 9.59859V2.68649C0 1.20332 1.00292 0 2.23907 0Z'
        fill='currentColor'
      />
      <path
        d='M7.99981 3.7149C9.23596 3.7149 10.2389 4.91823 10.2389 6.40139V13.3135C10.2389 14.7967 9.23596 16 7.99981 16C6.76366 16 5.76074 14.7967 5.76074 13.3135V6.40139C5.76074 4.91823 6.76366 3.7149 7.99981 3.7149Z'
        fill='currentColor'
      />
      <path
        d='M13.7606 0.286865C14.9967 0.286865 15.9996 1.49019 15.9996 2.97335V12.446C15.9996 13.9292 14.9967 15.1325 13.7606 15.1325C12.5244 15.1325 11.5215 13.9292 11.5215 12.446V2.97335C11.5215 1.49019 12.5244 0.286865 13.7606 0.286865Z'
        fill='currentColor'
      />
    </svg>
  )
}
